<template>
  <section class="tech-section">
    <!-- 核心团队部分 -->
    <!-- <div class="team-section">
      <div class="section-header">
        <h2 class="section-title">{{ translations[locale].team.title }}</h2>
        <p class="section-subtitle">{{ translations[locale].team.subtitle }}</p>
      </div>

      <div class="team-grid">
        <div class="team-card">
          <img src="@/assets/img/head_img1.png" alt="{{ translations[locale].team.membersOne.name }}" class="member-avatar">
          <h3 class="member-name">{{ translations[locale].team.membersOne.name }}</h3>
          <p class="member-title">{{ translations[locale].team.membersOne.title }}</p>
          <p class="member-description">{{ translations[locale].team.membersOne.description }}</p>
        </div>
        <div class="team-card">
          <img src="@/assets/img/head_img2.png" alt="{{ translations[locale].team.membersTwo.name }}" class="member-avatar">
          <h3 class="member-name">{{ translations[locale].team.membersTwo.name }}</h3>
          <p class="member-title">{{ translations[locale].team.membersTwo.title }}</p>
          <p class="member-description">{{ translations[locale].team.membersTwo.description }}</p>
        </div>
        <div class="team-card">
          <img src="@/assets/img/head_img3.png" alt="{{ translations[locale].team.membersThree.name }}" class="member-avatar">
          <h3 class="member-name">{{ translations[locale].team.membersThree.name }}</h3>
          <p class="member-title">{{ translations[locale].team.membersThree.title }}</p>
          <p class="member-description">{{ translations[locale].team.membersThree.description }}</p>
        </div>
        <div class="team-card">
          <img src="@/assets/img/head_img4.png" alt="{{ translations[locale].team.membersFour.name }}" class="member-avatar">
          <h3 class="member-name">{{ translations[locale].team.membersFour.name }}</h3>
          <p class="member-title">{{ translations[locale].team.membersFour.title }}</p>
          <p class="member-description">{{ translations[locale].team.membersFour.description }}</p>
        </div>
      </div>
    </div> -->

    <!-- 合作伙伴部分 -->
    <div class="partners-section">
      <div class="section-header">
        <h2 class="section-title">{{ translations[locale].partners.title }}</h2>
        <p class="section-subtitle">{{ translations[locale].partners.subtitle }}</p>
      </div>

      <div class="partners-grid">
        <div class="partner-logo">
          <img src="@/assets/img/join_img6.png">
        </div>
        <div class="partner-logo">
          <img src="@/assets/img/join_img7.png">
        </div>
        <div class="partner-logo">
          <img src="@/assets/img/join_img8.png">
        </div>
        <div class="partner-logo">
          <img src="@/assets/img/join_img9.png">
        </div>
        <div class="partner-logo">
          <img src="@/assets/img/join_img10.png">
        </div>
        <div class="partner-logo">
          <img src="@/assets/img/join_img4.png">
        </div>
        <div class="partner-logo">
          <img src="@/assets/img/join_img5.png">
        </div>
      </div>
    </div>

    <!-- CTA部分 -->
    <div class="cta-section">
      <div class="section-header">
        <h2 class="section-title">{{ translations[locale].cta.title }}</h2>
        <p class="section-subtitle">{{ translations[locale].cta.subtitle }}</p>
      </div>

      <div class="cta-buttons">
        <button class="btn btn-primary">{{ translations[locale].cta.startButton }}</button>
        <button class="btn btn-outline">{{ translations[locale].cta.docsButton }}</button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/stores/language'

const store = useStore()
const locale = computed(() => store.locale)

const translations = {
  zh: {
    team: {
      title: '覈心團隊',
      subtitle: '由區塊鏈、金融科技和人工智慧領域的專家組成',
      membersOne: {
        name: '張明遠',
        title: '首席執行官',
        description: '前Google區塊鏈技術負責人,10年區塊鏈行業經驗'
      },
      membersTwo: {
        name: '林雨晴',
        title: '首席科技官',
        description: '前阿裡巴巴科技專家,區塊鏈架構師'
      },
      membersThree: {
        name: '王志强',
        title: '首席財務官',
        description: '前摩根士丹利副總裁,金融科技專家'
      },
      membersFour: {
        name: '陳美玲',
        title: '首席運營官',
        description: '前騰訊區塊鏈業務總監,產品專家'
      }
    },
    partners: {
      title: '合作夥伴',
      subtitle: '與全球頂尖機构建立戰略合作夥伴關係'
    },
    cta: {
      title: '開始使用KOMA',
      subtitle: '立即加入KOMA生態系統,開啟您的區塊鏈之旅',
      startButton: '立即開始',
      docsButton: '查看文檔'
    }
  },
  en: {
    team: {
      title: 'Core Team',
      subtitle: 'Composed of experts in blockchain, fintech, and artificial intelligence',
      membersOne: {
        name: 'Zhang Mingyuan',
        title: 'Chief Executive Officer',
        description: 'Former Google Blockchain Technology Lead with 10 years of blockchain industry experience'
      },
      membersTwo: {
        name: 'Lin Yuqing',
        title: 'Chief Technology Officer',
        description: 'Former Alibaba Technical Expert and Blockchain Architect'
      },
      membersThree: {
        name: 'Wang Zhiqiang',
        title: 'Chief Financial Officer',
        description: 'Former Morgan Stanley Vice President and Fintech Expert'
      },
      membersFour: {
        name: 'Chen Meiling',
        title: 'Chief Operating Officer',
        description: 'Former Tencent Blockchain Business Director and Product Expert'
      }
    },
    partners: {
      title: 'Partners',
      subtitle: 'Building strategic partnerships with global leading institutions'
    },
    cta: {
      title: 'Get Started with KOMA',
      subtitle: 'Join the KOMA ecosystem now and start your blockchain journey',
      startButton: 'Get Started',
      docsButton: 'View Docs'
    }
  }
}
</script>

<style lang="scss" scoped>
.tech-section {
  width: 100%;
  margin: 0 auto;
  padding: 96px 0;

  .section-header {
    text-align: center;
    margin-bottom: 48px;
  }

  .section-title {
    font-size: clamp(24px, 5vw, 36px);
    font-weight: 700;
    color: #F8FAFC;
    margin-bottom: 16px;
  }

  .section-subtitle {
    font-size: clamp(14px, 3vw, 16px);
    color: #4B5563;
    max-width: 672px;
    margin: 0 auto;
  }
}

.team-section {
  padding: 0 0 32px 0;
  background: #F9FAFB;
  margin-bottom: 96px;

  .team-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 32px;
    max-width: 1376px;
    margin: 0 auto;
  }

  .team-card {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 32px;
    text-align: center;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }
  }

  .member-avatar {
    width: 128px;
    height: 128px;
    border-radius: 50%;
    margin-bottom: 24px;
    object-fit: cover;
  }

  .member-name {
    font-size: 20px;
    font-weight: 600;
    color: #F8FAFC;
    margin-bottom: 8px;
  }

  .member-title {
    font-size: 16px;
    color: #4B5563;
    margin-bottom: 16px;
  }

  .member-description {
    font-size: 14px;
    color: #6B7280;
    line-height: 1.5;
  }
}

.partners-section {
  padding: 0 32px;
  margin-bottom: 96px;

  .partners-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 32px;
    max-width: 1376px;
    margin: 0 auto;
    align-items: center;
  }

  .partner-logo {
    img {
      width: 100%;
      height: auto;
      max-width: 250px;
      margin: 0 auto;
      display: block;
    }
  }
}

.cta-section {
  background: #6366F1;
  padding: 96px 32px;
  text-align: center;

  .section-title {
    color: #FFFFFF;
  }

  .section-subtitle {
    color: rgba(255, 255, 255, 0.8);
  }

  .cta-buttons {
    display: flex;
    gap: 32px;
    justify-content: center;
    margin-top: 48px;
  }

  .btn {
    padding: 16px 32px;
    border-radius: 4px;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;

    &-primary {
      background: #FFFFFF;
      color: #6366F1;
      border: none;

      &:hover {
        background: rgba(255, 255, 255, 0.9);
      }
    }

    &-outline {
      background: transparent;
      color: #FFFFFF;
      border: 1px solid #FFFFFF;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }
}

@media (max-width: 768px) {
  .tech-section {
    padding: 48px 0;
  }

  .team-section,
  .partners-section {
    padding: 0 16px;
  }

  .cta-section {
    padding: 48px 16px;
  }

  .cta-buttons {
    flex-direction: column;
    gap: 16px;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 24px;
  }

  .section-subtitle {
    font-size: 14px;
  }

  .team-card {
    padding: 24px;
  }

  .member-avatar {
    width: 96px;
    height: 96px;
  }
}
</style>